// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-statut {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  background: #f9fafb;
  box-sizing: border-box;
}

/* Enrobee dans le layout connecte (navbar au-dessus) : on ne force pas tout le viewport,
   et on laisse le fond du layout transparaitre. */
.page-statut--embedded {
  min-height: 65vh;
  background: transparent;
  padding: 4rem 2rem 6rem;
}

.page-statut-card {
  max-width: 52rem;
  width: 100%;
  text-align: center;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 1.6rem;
  padding: 5rem 4rem;
  box-shadow: 0 1rem 4rem rgba(17, 24, 39, 0.06);
}

.page-statut-logo {
  height: 4.8rem;
  width: auto;
  max-width: 100%;
  display: block;
  margin: 0 auto 2.4rem;
}

.page-statut-code {
  font-size: 6.4rem;
  font-weight: 800;
  line-height: 1;
  color: #f97316;
  letter-spacing: -0.02em;
  margin-bottom: 1.2rem;
}

.page-statut-titre {
  font-size: 2.4rem;
  font-weight: 700;
  color: #595959;
  margin: 0 0 1.2rem;
}

.page-statut-message {
  font-size: 1.6rem;
  line-height: 1.6;
  color: #374151;
  margin-bottom: 3.2rem;
}

.page-statut-actions {
  display: flex;
  gap: 1.2rem;
  justify-content: center;
  flex-wrap: wrap;
}

/* Maintenance : registre plus sobre, le code (503) en gris plutot qu'orange. */
.page-statut--maintenance .page-statut-code {
  color: #595959;
}

@media (max-width: 600px) {
  .page-statut-card {
    padding: 3.6rem 2rem;
  }
  .page-statut-code {
    font-size: 4.8rem;
  }
  .page-statut-titre {
    font-size: 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/composants/PageStatut/PageStatut.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;kDACkD;AAClD;EACE,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;;AAEA,+EAA+E;AAC/E;EACE,cAAc;AAChB;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".page-statut {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  background: #f9fafb;\n  box-sizing: border-box;\n}\n\n/* Enrobee dans le layout connecte (navbar au-dessus) : on ne force pas tout le viewport,\n   et on laisse le fond du layout transparaitre. */\n.page-statut--embedded {\n  min-height: 65vh;\n  background: transparent;\n  padding: 4rem 2rem 6rem;\n}\n\n.page-statut-card {\n  max-width: 52rem;\n  width: 100%;\n  text-align: center;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 1.6rem;\n  padding: 5rem 4rem;\n  box-shadow: 0 1rem 4rem rgba(17, 24, 39, 0.06);\n}\n\n.page-statut-logo {\n  height: 4.8rem;\n  width: auto;\n  max-width: 100%;\n  display: block;\n  margin: 0 auto 2.4rem;\n}\n\n.page-statut-code {\n  font-size: 6.4rem;\n  font-weight: 800;\n  line-height: 1;\n  color: #f97316;\n  letter-spacing: -0.02em;\n  margin-bottom: 1.2rem;\n}\n\n.page-statut-titre {\n  font-size: 2.4rem;\n  font-weight: 700;\n  color: #595959;\n  margin: 0 0 1.2rem;\n}\n\n.page-statut-message {\n  font-size: 1.6rem;\n  line-height: 1.6;\n  color: #374151;\n  margin-bottom: 3.2rem;\n}\n\n.page-statut-actions {\n  display: flex;\n  gap: 1.2rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n/* Maintenance : registre plus sobre, le code (503) en gris plutot qu'orange. */\n.page-statut--maintenance .page-statut-code {\n  color: #595959;\n}\n\n@media (max-width: 600px) {\n  .page-statut-card {\n    padding: 3.6rem 2rem;\n  }\n  .page-statut-code {\n    font-size: 4.8rem;\n  }\n  .page-statut-titre {\n    font-size: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
